var forgotEmailController = {
    forgotModal: $('#forgotModal'),
    forgotModalCode: $('#forgotModalEmailCode'),
    forgotModalFailed: $('#forgotModalEmailFailed'),
    elForm: $('#forgotEmailForm'),
    email: '',
    init: function()
    {
        forgotEmailController.clearForm();

        forgotEmailController.elForm.on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();

                return false;
            }
        });

        forgotEmailController.elForm.find('.js-input-email').on('click change keyup blur input', function() {
            forgotEmailController.email = $(this).val().trim();
        });

        forgotEmailController.elForm.find('button').click(function() {
            forgotEmailController.submitForm();

            return false;
        });

        forgotEmailController.forgotModalCode.find('.js-send-again').click(function() {
            forgotEmailController.submitForm();

            return false;
        });
    },
    submitForm: function()
    {
        if (!forgotEmailController.validateForm()) {
            forgotEmailController.showError();

            return false;
        }

        $.post(
            forgotEmailController.elForm.attr('action'),
            forgotEmailController.elForm.serialize(),
            function(data){
                if (data.success) {
                    forgotEmailController.forgotModalCode.modal('show');
                    forgotEmailController.forgotModalCode.find('.tip-text span').text(forgotEmailController.email);
                    forgotEmailController.forgotModalCode.find('.js-input-email').val(forgotEmailController.email);
                    forgotEmailController.forgotModal.modal('hide');
                    authBaseController.startCountdown(
                        forgotEmailController.forgotModalCode.find('.js-countdown'),
                        forgotEmailController.forgotModalCode.find('.js-send-again')
                    );
                    forgotEmailController.elForm.find('.js-input-email').val('');
                } else {
                    if(!data.isUserExists) {
                        forgotEmailController.forgotModalFailed.find('.text-top').text(data.message);
                        forgotEmailController.forgotModalFailed.modal('show');
                        forgotEmailController.forgotModal.modal('hide');
                    } else {
                        forgotEmailController.forgotModal.find('.error-text').text(data.message);
                        forgotEmailController.showError();
                    }
                }
        });
    },
    validateForm: function()
    {
        forgotEmailController.clearForm();
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return (forgotEmailController.email.length > 3 && regex.test(forgotEmailController.email));
    },
    clearForm: function()
    {
        forgotEmailController.elForm.find('.form-group').removeClass('has-error');
        forgotEmailController.elForm.find('.error-text').hide();
    },
    showError: function()
    {
        forgotEmailController.elForm.find('.form-group').addClass('has-error');
        forgotEmailController.elForm.find('.error-text').show();
    }
};

$(function(){
    forgotEmailController.init();
});